
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/domestic-shipping-services",
      function () {
        return require("private-next-pages/domestic-shipping-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/domestic-shipping-services"])
      });
    }
  